import React from 'react';
import TextField from '@material-ui/core/TextField';

const PriceRuleTextbox = ({ value, setValue, label, style = {}, variant = 'outlined' }) => (
    <TextField
        variant={variant}
        style={style}
        label={label}
        value={value}
        onChange={event => setValue(event.target.value)}
    />
);

export default PriceRuleTextbox;
